export default __webpack_public_path__ + "static/media/netflix.6e288fc3.jpg";